import React, { useState, Fragment } from "react";
import { Accordion, Divider } from "semantic-ui-react";
import { ControlledObservationFormFields, IAuditNote, IAuditNoteFormData, TEditableAuditNote } from "../../interfaces/IAuditNote";
import IFormType from "../../interfaces/IFormType";
import { NoteAccordionItem, NoteAccordionItemProps } from "./NoteAccordionItem";
import "./_NoteAccordion.less"

interface AuditNoteListProps {
    notes: TEditableAuditNote[];
    onRemove?: (noteId: IAuditNote["id"]) => void;
    onUpdate?: (id: number, updates: Partial<TEditableAuditNote>) => void;

    fieldTitle: string;
    formType: IFormType["id"];
    observationFormReference?: string;
};

export const NoteAccordion: React.FC<AuditNoteListProps> = ({
    fieldTitle,
    notes,
    onRemove,
    onUpdate,

    formType,
    observationFormReference
}) => {

    const [activeIndex, setActiveItem] = useState<number | null>();


    const renderAccordionItem = (index: number, props: NoteAccordionItemProps) => {
        const toggle = () => setActiveItem((prevIndex) => prevIndex === index ? null : index);
        const remove = (id: IAuditNote["id"]) => {
            onRemove && onRemove(id);
            setActiveItem(null)
        }
        return (
            <Fragment>

                <NoteAccordionItem
                    {...props}
                    fieldTitle={fieldTitle}
                    active={activeIndex === index}
                    onTitleClick={toggle}
                    onRemove={onRemove && remove}
                    onUpdate={onUpdate}
                />
            </Fragment>
        );
    };

    const renderNote = (note: TEditableAuditNote, index: number) => {
        if (note.submitStatus && note.submitStatus !== "submitted") {

            return renderAccordionItem(index, {
                fieldTitle,
                formType,
                observationFormReference,
                note
            });
        };

        return renderAccordionItem(index, {
            fieldTitle,
            note,
            formType,
            observationFormReference
        });
    };

    if (!notes.length) {
        return null;
    };

    return (
        <Accordion className="NoteAccordion" >
            {notes.map(renderNote)}
            {notes.length && <Divider hidden />}
        </Accordion>
    );
};
